import React, { Component, Fragment, createRef } from "react";
import { Multiselect } from 'multiselect-react-dropdown';
import AppContext from "../../contexts/AppContext";
import Progress from "./include/Progress";
import OnboardingSteps from "./include/OnboardingSteps";
import { CheckoutNew } from "./CheckoutNew";


export class BillingDetails extends Component {
	
	scrollDiv = createRef();
	
	constructor(){
        super();
        this.state = {
			interest : "0",
		}
    }
	
	checkInterest = Id => {
		this.setState({ interest: this.state.interest === Id ? "0" : Id });
    };
	
	componentDidMount() {
		this.context.state.updateMetaData('checkout-steps');
		this.scrollDiv.current.scrollIntoView({ behavior: "smooth" });
	};
	
	render() {
		
		return (
            <Fragment>
			    <section className="checkout-process resp-checkout-process py-md-6 py-sm-5 py-4" ref={this.scrollDiv}>
				    <div className="container">	
					    <div className="sub-container mx-auto">
				            <div className="row no-gutters">
				                <div className="col-xl-3 col-lg-4 col-md-4">
				            	    <OnboardingSteps onboardStep="[1,2,3,4]" show="4"></OnboardingSteps>
				            	</div>
				            	<div className="col-xl-9 col-lg-8 col-md-8">
				            	    <div className="bg-white checkout new">
									    <div className="create-profile mx-auto mb-3 p-0">
										    <div className="title">
											    <img className="mx-auto d-block mb-3" src="/images/logo_dark.png" alt="pw-logo" width="30" height="46"/>
												<h2 className="text-center mb-3">Final Step! Confirm & Activate Membership</h2>
												<p className="text-center mb-4">50% off first year discount applied. LIMITED TIME ONLY.</p>
											</div>
											<Progress ariavalue="75" content="Step 3 of 3...." width="75%"></Progress>
                                            <CheckoutNew></CheckoutNew>
                                        </div>
									</div>
				            	</div>
				            </div>
						</div>	
					</div>
				</section>
			</Fragment>
		);
	}	
}

BillingDetails.contextType = AppContext;
export default BillingDetails;	


// WEBPACK FOOTER //
// ./src/components/general/BillingDetails.js